/**
 * Button variations
 * @default primary
 */
export type Variant =
  | 'primary'
  | 'primary-green'
  | 'primary-dusk-green'
  | 'main-cta'
  | 'secondary-main'
  | 'secondary'
  | 'text'
  | 'text-underlined'
  | 'text-black'
  | 'text-white'
  | 'text-destructive'
  | 'destructive-primary'
  | 'destructive-secondary'
  | 'circular-primary'
  | 'circular-primary-green'
  | 'circular-main-cta'
  | 'circular-outline-black'
  | 'circular-outline-primary'
  | 'circular-outline-white'
  | 'outline-black'
  | 'outline-primary-greeb'
  | 'circular-outline-primary'
  | 'outline-white'
  | 'outline-radio-inactive'
  | 'radio-primary-green'
  | 'radio-outline-not-selected';

export const VARIANT: { [key: string]: Variant | string } = {
  PRIMARY: 'primary',
  PRIMARY_GREEN: 'primary-green',
  PRIMARY_DUSK_GREEN: 'primary-dusk-green',
  MAIN_CTA: 'main-cta',
  SECONDARY: 'secondary',
  SECONDARY_MAIN: 'secondary-main',
  TEXT: 'text',
  TEXT_UNDERLINED: 'text-underlined',
  TEXT_BLACK: 'text-black',
  TEXT_WHITE: 'text-white',
  TEXT_DESTRUCTIVE: 'text-destructive',
  DESTRUCTIVE_PRIMARY: 'destructive-primary',
  DESTRUCTIVE_SECONDARY: 'destructive-secondary',
  CIRCULAR_PRIMARY: 'circular-primary',
  CIRCULAR_PRIMARY_GREEN: 'circular-primary-green',
  CIRCULAR_MAIN_CTA: 'circular-main-cta',
  CIRCULAR_OUTLINE_PRIMARY: 'circular-outline-primary',
  CIRCULAR_OUTLINE_WHITE: 'circular-outline-white',
  OUTLINE_PRIMARY: 'outline-primary',
  OUTLINE_PRIMARY_GREEN: 'outline-primary-green',
  OUTLINE_BLACK: 'outline-black',
  OUTLINE_WHITE: 'outline-white',
  OUTLINE_RADIO_INACTIVE: 'outline-radio-inactive',
  RADIO_PRIMARY_GREEN: 'radio-primary-green',
  RADIO_OUTLINE_NOT_SELECTED: 'radio-outline-not-selected'
};

export default VARIANT;
